import './SmartBadge.css';

/**
 * props:
 * -id
 * - text
 * - onClick
 */
function SmartBadge(props) {
    return (
        <div className="input-group me-2 mb-2 d-flex flex-row smart-badge">
            <span id="spanNoWrap" className="alert alert-info py-1 smart-badge-text">
                {props.children} {props.text}
            </span>
            <button id={props.id} type="button" className="btn btn-info btn-xs alert" title="Click to Remove" onClick={props.onClick}>X</button>
        </div>
    )
}

export default SmartBadge;